import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface Company {
  company_id: string;
  company_name: string;
  address: string;
  country_iso?: string;
}

interface CompanyContextType {
  selectedCompany: Company | null;
  setSelectedCompany: (company: Company | null) => void;
  userCompanies: Company[];
  setUserCompanies: (companies: Company[]) => void;
}
  
const CompanyContext = createContext<CompanyContextType>({
  selectedCompany: null,
  setSelectedCompany: () => {},
  userCompanies: [],
  setUserCompanies: () => {},
});

export const CompanyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedCompany, setSelectedCompanyState] = useState<Company | null>(null);
  const [userCompanies, setUserCompanies] = useState<Company[]>([]);

  useEffect(() => {
    const savedCompany = localStorage.getItem('selectedCompany');
    if (savedCompany) {
      try {
        const parsedCompany = JSON.parse(savedCompany);
        setSelectedCompanyState(parsedCompany);
      } catch (error) {
        console.error('Error parsing saved company:', error);
        localStorage.removeItem('selectedCompany');
      }
    }
  }, []);

  const setSelectedCompany = (company: Company | null) => {
    setSelectedCompanyState(company);
    
    if (company) {
      localStorage.setItem('selectedCompany', JSON.stringify(company));
    } else {
      localStorage.removeItem('selectedCompany');
    }
  };
  return (
    <CompanyContext.Provider value={{ 
      selectedCompany, 
      setSelectedCompany, 
      userCompanies, 
      setUserCompanies 
    }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => useContext(CompanyContext);